/** Date formatting utilities */

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric', month: 'short', day: 'numeric',
});

const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric', month: 'short', day: 'numeric',
  hour: 'numeric', minute: '2-digit',
});

/**
 * Format an ISO date string (YYYY-MM-DD or full ISO) as "Jan 15, 2025"
 */
export function formatDate(isoDate) {
  if (!isoDate) return '—';
  const d = new Date(isoDate.includes('T') ? isoDate : isoDate + 'T00:00:00');
  return dateFormatter.format(d);
}

/**
 * Format an ISO datetime string as "Jan 15, 2025, 2:30 PM"
 */
export function formatDateTime(isoDate) {
  if (!isoDate) return '—';
  return dateTimeFormatter.format(new Date(isoDate));
}

/**
 * Return ISO date string for today (YYYY-MM-DD) in local time.
 */
export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

/**
 * Determine due state for a date string (YYYY-MM-DD).
 * Returns 'overdue' | 'today' | 'soon' | 'future' | null
 */
export function dueState(dateStr) {
  if (!dateStr) return null;
  const today = todayISO();
  if (dateStr < today) return 'overdue';
  if (dateStr === today) return 'today';
  const in14 = new Date(Date.now() + 14 * 86400000).toISOString().slice(0, 10);
  if (dateStr <= in14) return 'soon';
  return 'future';
}

/**
 * Format a timezone identifier for display.
 * "America/New_York" → "Eastern Time (ET)"
 */
export function formatTimezone(tz) {
  if (!tz) return '';
  try {
    const abbr = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'short' })
      .formatToParts()
      .find((p) => p.type === 'timeZoneName')?.value ?? tz;
    return `${tz.replace(/_/g, ' ')} (${abbr})`;
  } catch {
    return tz;
  }
}

/** Days until a date (negative = overdue) */
export function daysUntil(dateStr) {
  if (!dateStr) return null;
  const diff = new Date(dateStr + 'T00:00:00').getTime() - Date.now();
  return Math.ceil(diff / 86400000);
}
